import keyBy from 'lodash/keyBy';

import {propertyDefinitionsClient} from 'common/report/queries/app-api/property-definitions-client';
import {PropertyDefinition} from 'common/util/definitions-types';

import {Store} from './store';

export interface PropertyDefinitionMap {
  [propertyName: string]: PropertyDefinition;
}

const transform = {
  index: (definitions) => keyBy(definitions, `name`),
  update: (definitions) => ({k: definitions.name, v: definitions}),
};

export const eventPropertyDefinitionsStore = new Store<PropertyDefinitionMap>({
  apiClient: propertyDefinitionsClient,
  defaultValue: {},
  name: `event-property-definitions`,
  transform,
});

export const peoplePropertyDefinitionsStore = new Store<PropertyDefinitionMap>({
  apiClient: propertyDefinitionsClient,
  defaultValue: {},
  name: `people-property-definitions`,
  transform,
});
